<template>
  <div id="app">
    <header-component />
    <divider-component />
    <calculation-input />
    <divider-component />
    <calculation-output v-if="validCalculation" />
    <divider-component v-if="validCalculation" />
    <calculation-request v-if="validCalculation" />
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./components/Header";
import FooterComponent from "./components/Footer";
import DividerComponent from "./components/Divider";
import CalculationInput from "./components/CalculationInput";
import CalculationOutput from "./components/CalculationOutput";
import CalculationRequest from "./components/CalculationRequest";
import { mapState } from "vuex";
import axios from 'axios';

export default {
  name: "App",
  components: {
    HeaderComponent,
    DividerComponent,
    FooterComponent,
    CalculationInput,
    CalculationOutput,
    CalculationRequest
  },
  computed: {
    ...mapState(["selectedProperties", "culture"]),
    validCalculation() {
      return (
        this.selectedProperties.length >= 4000 &&
        this.selectedProperties.length <= 8000 &&
        this.selectedProperties.width >= 1 &&
        this.selectedProperties.rcValue
      );
    }
    },
    mounted() {
      let i18n = this.$i18n;
      let store = this.$store;
      axios.get('./api/cultureinfo/info')
        .then(function (response) {
          if (response.status === 200) {
            i18n.locale = response.data;
            store.commit("SET_CULTURE", response.data);
          }
            
        })
        .catch(function (response) {
          console.log(response);
        })

      axios.get('./api/cultureinfo/combipak')
        .then(function (response) {
          if (response.status === 200) {
            store.commit("SET_COMBIPAK", response.data);
          }
        })
        .catch(function (response) {
          console.log(response);
        })
    }
};
</script>

<style lang="scss">
@import "./assets/scss/base";
</style>
